import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useEffect } from "react"
import { useForm } from "react-hook-form"
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom"
import { ToastContent, toast } from "react-toastify"
import { handleLoader } from "redux/counterSlice";
import { addGroupService, updateGroupService } from "services/groupService"

type IGroupDetails = {
	name: string
	description: string
	add: boolean
	edit: boolean
}

const GroupDetails = ({ name, description, add, edit }: IGroupDetails) => {
	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
	} = useForm()

	const params = useParams()
	const navigate = useNavigate()
	const dispatch = useDispatch();
	useEffect(() => {
		setValue("name", name)
		setValue("description", description)
	}, [description, name, setValue])

	const getFormErrorMessage = (name: string) => {
		return (
			errors[name] && (
				<small className="p-error">{errors[name]?.message?.toString()}</small>
			)
		)
	}

	const onSubmit = async (data: { [x: string]: any }) => {
		dispatch(handleLoader(true));
		try {
			// if (params.id === "add" && add) {
			// 	const serviceBody = {
			// 		group_name: data?.name,
			// 		description: data?.description,
			// 		created_by: window && window.localStorage.getItem("username"),
			// 	}
			// 	let { error, response } = await addGroupService(serviceBody)
			// 	if (response?.error) {
			// 		throw response?.error
			// 	}
			// 	if (error) {
			// 		throw error
			// 	}
			// 	toast.success(response?.message)
			// 	navigate("/admin/groups")
			// } else 
			if (edit) {
				const serviceBody = {
					group_id: Number(params.id),
					group_name: data?.name,
					description: data?.description,
					updated_by: window && window.localStorage.getItem("username")!,
				}
				let { error, response } = await updateGroupService(serviceBody)
				if (error) {
					throw error
				}
				if (response?.error) {
					throw response?.error
				}
				toast.success(response?.message, {
					style: {
						backgroundColor: '#F1F1F1', // Grey background
					}
				})
				navigate("/admin/groups")
			}
			dispatch(handleLoader(false));
		} catch (error) {
			dispatch(handleLoader(false));
			toast.error(error as ToastContent<unknown>, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)} className="group-form">
			<div className='form-row'>
				<div className='form-col'>
					<label className="form-label">Name of Group<i>*</i></label>
					<InputText
						{...register("name", {
							required: {
								value: true,
								message: "Group Name is required",
							},
						})}
						placeholder="Name of Group"
					/>
					{getFormErrorMessage("name")}
				</div>
			</div>
			<div className='form-row'>
				<div className='form-col'>
					<label className="form-label">Description<i>*</i></label>
					<InputTextarea rows={6} className="form-control p-inputtext-lg"
						{...register("description", {
							required: {
								value: true,
								message: "Description is required",
							},
						})}
						placeholder="Add group description here..."
					/>
					{getFormErrorMessage("description")}
				</div>
			</div>
			<div className="col-md-12 d-flex justify-content-start">
				<Button
					type="button"
					className="outline-icon-btn mr-3"
					onClick={() => {
						navigate("/admin/groups")
					}}
				>
					Cancel
				</Button>
				<Button className="outline-active-btn" type="submit">
					Save
				</Button>
			</div>
		</form>
	)
}

export default GroupDetails
